import type { RadioChangeEvent } from 'antd';
import { Radio } from 'antd';
import type { CheckboxGroupProps } from 'antd/es/checkbox';
import { useMediaQuery } from 'beautiful-react-hooks';
import { MEDIA_QUERIES } from 'config/style/breakpoints';
import InfoButton from '@features/regional-overview/digital-traps/components/info-button/info-button.component';
import { useFlightPredictions } from '@features/regional-overview/digital-traps/components/trap-details/flight-predictions/flight-predictions.hook';
import {
  FLIGHT_CURVE_GRAPH_HEADER,
  FLIGHT_CURVE_GRAPH_HEADER_DAYS_RANGE,
  FLIGHT_CURVE_GRAPH_HEADER_TITLE
} from '@features/regional-overview/digital-traps/domain/tests-id.constants';
import { useTranslation } from 'react-i18next';
import { FiltersWrapper, HeaderWrapper, Title } from './graph-header.styles';

interface GraphHeaderProps {
  selectedNetwork: string;
  selectedDays: number;
  onDaysChange: (e: RadioChangeEvent) => void;
}

export const GraphHeader = ({ selectedNetwork, selectedDays, onDaysChange }: GraphHeaderProps) => {
  const [t] = useTranslation();
  const { anyTrapHasFlightPredictions } = useFlightPredictions();
  const isMobile = useMediaQuery(MEDIA_QUERIES.MOBILE);

  const rangeOptions: CheckboxGroupProps<number>['options'] = [
    { label: t('pages.regional_overview.digital_traps.flight_curve.last_7_days'), value: 7 },
    { label: t('pages.regional_overview.digital_traps.flight_curve.last_15_days'), value: 15 },
    { label: t('pages.regional_overview.digital_traps.flight_curve.last_30_days'), value: 30 },
    { label: t('pages.regional_overview.digital_traps.flight_curve.last_60_days'), value: 60 }
  ];

  return (
    <HeaderWrapper data-testid={FLIGHT_CURVE_GRAPH_HEADER}>
      <Title data-testid={FLIGHT_CURVE_GRAPH_HEADER_TITLE}>
        <b>{selectedNetwork}:</b> {t('pages.regional_overview.digital_traps.flight_curve.header_text')}
      </Title>
      <FiltersWrapper>
        {anyTrapHasFlightPredictions && <InfoButton onlyIcon={true} />}
        <Radio.Group
          options={rangeOptions}
          defaultValue={selectedDays}
          optionType='button'
          buttonStyle='solid'
          block={isMobile}
          onChange={onDaysChange}
          data-testid={FLIGHT_CURVE_GRAPH_HEADER_DAYS_RANGE}
        />
      </FiltersWrapper>
    </HeaderWrapper>
  );
};
